import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import RouteItem from "./RouteItem";


const RouteList = ({ routes = [] }) => {
    const timeMode = useSelector((state) => state.timemode);

    if (!routes.length) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Typography>No routes available</Typography>
            </Box>
        );
    }

    return (
        <Box 
            display="flex" 
            flexDirection="column"
            gap={2}
            sx={{ overflowY: 'auto' }}
        >
            {routes.map((route, idx) => (
                <RouteItem 
                    key={route._id || idx} 
                    idx={idx} 
                    timeMode={timeMode} 
                    route={route} 
                />
            ))}
        </Box>
    );
};

export default RouteList;